"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
function parseBoundingBox(xml) {
    var lowerCorner = (0, utils_1.findTagText)(xml, "ows:LowerCorner");
    var upperCorner = (0, utils_1.findTagText)(xml, "ows:UpperCorner");
    if (lowerCorner && upperCorner) {
        var _a = __read(lowerCorner.split(" ").map(function (str) { return Number(str); }), 2), west = _a[0], south = _a[1];
        var _b = __read(upperCorner.split(" ").map(function (str) { return Number(str); }), 2), east = _b[0], north = _b[1];
        return [west, south, east, north];
    }
    return undefined;
}
exports.default = parseBoundingBox;
